<script lang="ts">
  import { onMount } from 'svelte';
  import { isAuthenticated, authInitialized } from '$src/infrastructure/accounts/authStore';
  import { msalAuthenticator } from '$src/infrastructure/accounts/auth';
  import { get } from 'svelte/store';

  let authenticated = get(isAuthenticated);
  let initialized = get(authInitialized);

  onMount(() => {
    const unsubscribeAuth = isAuthenticated.subscribe(value => {
      authenticated = value;
    });

    const unsubscribeInit = authInitialized.subscribe(async value => {
      initialized = value;
      if (value && !authenticated) {
        msalAuthenticator.login();
      }
    });

    return () => {
      unsubscribeAuth();
      unsubscribeInit();
    };
  });
</script>

{#if $authInitialized}
  {#if $isAuthenticated}
    <slot />
  {:else}
    <p>Redirecting to login...</p>
  {/if}
{:else}
  <p>Loading...</p>
{/if}
